import Icon from 'components/Icon';
import {Typography} from 'components/Typography';
import {BrowserFilters} from 'plugins/modules/filter/helpers/BrowserFilters';
import classNames from 'classnames';
import React, {FC, useCallback, useMemo, useRef, useState} from 'react';
import style from './style.module.scss';
import {useRouter} from 'next/router';
import {IAppliedFilter} from 'plugins/modules/filter/helpers/BrowserFilters/AppliedFilters';
import {useAppliedFiltersList} from 'plugins/modules/filter/hooks/AppliedFilters/useAppliedFiltersList';
import {useClickOutside} from 'core/hooks/useClickOutside';
import {useFiltersGtag} from 'hooks/analytics/gtag/catalog/useFiltersGtag';
import {EventAction} from 'modules/google-analytics/constants';

export interface IProps {
    appliedFilters: IAppliedFilter[];
}

export const ShowFiltersButton: FC<IProps> = ({appliedFilters}) => {
    const router = useRouter();

    const sendFiltersGtag = useFiltersGtag();

    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    const handleOpen = useCallback(() => {
        setIsOpen(true);
    }, []);

    const handleClose = useCallback(() => {
        setIsOpen(false);
    }, []);

    useClickOutside([ref], () => {
        handleClose();
    });

    const filtersCount = appliedFilters.length;

    const sortedAppliedFilters = useMemo(() => {
        const filters = [...appliedFilters];

        return filters.reverse();
    }, [appliedFilters]);

    const filterInstance = useMemo(() => {
        return BrowserFilters.getInstance();
    }, []);

    const handleClear = useCallback(() => {
        sendFiltersGtag(undefined, EventAction.RemoveAllFilters, undefined);

        const {pathName} = filterInstance.userRemoveAllFilters();
        router.push(pathName, undefined, {scroll: false, shallow: true});
    }, [filterInstance, router, sendFiltersGtag]);

    const list = useAppliedFiltersList(sortedAppliedFilters);

    return (
        <div className={classNames(style.main, {[style.isOpen]: isOpen})} data-skeleton-item={true}>
            <button className={style.button} onClick={handleOpen} type={'button'}>
                <Icon className={style.icon} icon={'filter-new'} />
                <Typography className={style.counter} variant={'label-10-b'} data-skeleton-item={true}>
                    {filtersCount}
                </Typography>
            </button>
            {isOpen && (
                <div className={style.popup} ref={ref}>
                    <div className={style.popupHeader}>
                        <Icon className={style.popupFilterIcon} icon={'filter-new'} />
                        <Typography className={style.popupHeaderTitle} variant={'label-14-r-fluid'}>
                            Фильтры {filtersCount}
                        </Typography>
                        <button className={style.popupHeaderResetButton} onClick={handleClear} type={'button'}>
                            <Typography variant={'label-14-r'}>Сбросить</Typography>
                        </button>
                        <button className={style.popupCloseButton} onClick={handleClose} type={'button'}>
                            <Icon className={style.popupCloseIcon} icon={'close'} />
                        </button>
                    </div>
                    <div className={style.popupFiltersContainer}>{list}</div>
                </div>
            )}
        </div>
    );
};
